<script>
  import { adData } from "../Api/store";
  import { rafTimeOut } from "../../Helper";
  import { nanoid } from "nanoid";
  // TODO Replace `hideAdvertisement = true;` with `const hideAdvertisement = window.daj39sd;` when it the ad position is enabled
  const hideAdvertisement = true;

  const id = "ad" + nanoid();

  let timerDuration = null;
  let firstRun = true;

  adData.subscribe((storeObj) => {
    if (hideAdvertisement) {
      return;
    }

    const { timeout, spread, navigateCount, show } = storeObj;
    if (!navigateCount || show || spread <= 0 || !!(navigateCount % spread)) {
      return;
    }
    adData.update((storeObj) => {
      storeObj.show = true;
      storeObj.navigateCount = 0;
      return storeObj;
    });
    if (firstRun) {
      firstRun = false;
      window.addAdvertisment({ location: "ClickStory", id });
    }
    timerDuration = rafTimeOut(() => {
      timerDuration.clear();
      adData.update((storeObj) => {
        storeObj.show = false;
        return storeObj;
      });
    }, timeout * 1000);
  });
</script>

{#if $adData.show}
  <div aria-hidden="true" class="progress absolute inset-x-0 top-0 z-30 h-1 w-full origin-left bg-theme-signal" style="animation-duration:{$adData.timeout}s" />
{/if}
<aside {id} class="absolute inset-0 z-30 mt-12 flex items-start justify-center" class:hidden={!$adData.show} />

<style>
  .progress {
    animation-direction: normal;
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
    animation-name: progress;
    animation-timing-function: linear;
  }

  @keyframes progress {
    0% {
      transform: scaleX(0);
    }
    100% {
      transform: scaleX(1);
    }
  }
</style>
